import { useEffect } from 'react'

import { env } from '@/config'

export const useVConsole = () => {
  useEffect(() => {
    let vconsole: any = null

    if (import.meta.env.DEV || env.EVT_MODE !== 'production') {
      import('vconsole').then(({ default: VConsole }) => {
        vconsole = new VConsole()
      })
    }

    return () => {
      vconsole?.destroy()
    }
  }, [])
}
